export default "__VITE_ASSET__Bp3z24JP__"